import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const About = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section
      id="about"
      data-testid="about-section"
      ref={ref}
      className="relative py-32 md:py-48 px-6 md:px-12 lg:px-24 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24">
          {/* Left Column - Label */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-3"
          >
            <span className="font-heading font-bold text-sm tracking-[0.3em] text-white/40 uppercase">
              About
            </span>
            <div className="mt-4 w-12 h-[1px] bg-white/20" />
          </motion.div>

          {/* Right Column - Content */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-9"
          >
            <h2
              className="font-heading font-bold text-3xl md:text-5xl lg:text-6xl leading-tight mb-12"
              data-testid="about-heading"
            >
              WE CREATE
              <br />
              <span className="text-outline">SOUNDSCAPES</span>
            </h2>

            <p
              className="font-body text-lg md:text-xl lg:text-2xl text-white/70 leading-relaxed max-w-3xl"
              data-testid="about-description"
            >
              The combination of the best digital workstations in use with vintage
              instruments and analog systems gives to the studio the possibility
              to realize music and audio productions without limits, such as{' '}
              <span className="text-white font-medium">Sound Design</span>,{' '}
              <span className="text-white font-medium">Original Music Composition</span>,{' '}
              <span className="text-white font-medium">Cover and Music Re-Arrangements</span>.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;